/** @format */

import React from "react";

const RenewalCard = ({ children, active, ...props }) => {
  return (
    <div className={`renewal-card ${active ? "active" : ""}`} {...props}>
      {children}
    </div>
  );
};

export default RenewalCard;
